/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

import { Tools } from "../utilities/Tools.js";

class TableCaption {
    constructor(caption) {
        this.caption = caption;
        this.collapseInstances = new Map();
        this.collapseToggles = [].slice.call(this.caption.querySelectorAll('[data-toggle="collapse"]'));
        this._collapseActiveInstance = null;
        this.hideBind = this.hide.bind(this);
        this.init();
    }

    get collapseActiveInstance() {
        return this._collapseActiveInstance;
    }

    set collapseActiveInstance(value) {
        this._collapseActiveInstance = value;
    }

    events() {
        const _this = this;

        document.addEventListener(
            "switch.change",
            function (event) {
                _this.toggleAll(event.detail.switch);
            },
            false
        );

        if (this.collapseToggles.length > 0) {
            this.collapseToggles.forEach(function (toggle, index) {
                toggle.addEventListener("click", function (event) {
                    const instance = _this.collapseInstances.get(this.dataset.target);

                    instance.toggle();
                });
            });
        }

        _this.collapseInstances.forEach(function (collapse, index) {
            collapse._element.addEventListener("shown.bs.collapse", function (event) {
                event.stopPropagation();

                if (Tools.matchMedia("(min-width: 1200px)")) {
                    if (!event.target.classList.contains("save-as-collapse")) {
                        return false;
                    } else {
                        //
                        _this.caption.classList.toggle("table-caption--collapse-active");
                    }
                } else {
                    if (!event.target.classList.contains("navbar-collapse")) {
                        return false;
                    } else {
                        //
                        _this.caption.classList.toggle("table-caption--collapse-active");
                    }
                }

                //
                _this.collapseActiveInstance = _this.collapseInstances.get("#" + event.target.id);

                //
                document.addEventListener("click", _this.hideBind);
            });

            collapse._element.addEventListener("hidden.bs.collapse", function (event) {
                event.stopPropagation();

                if (Tools.matchMedia("(min-width: 1200px)")) {
                    if (!event.target.classList.contains("save-as-collapse")) {
                        return false;
                    } else {
                        //
                        _this.caption.classList.toggle("table-caption--collapse-active");
                    }
                } else {
                    if (!event.target.classList.contains("navbar-collapse")) {
                        return false;
                    } else {
                        //
                        _this.caption.classList.toggle("table-caption--collapse-active");
                    }
                }

                //
                document.removeEventListener("click", _this.hideBind);
            });
        });
    }

    hide(event) {
        if (Tools.matchMedia("(min-width: 1200px)")) {
            if (Boolean(event.target.closest(".save-as-collapse"))) {
                return false;
            }
        } else {
            if (
                Boolean(event.target.closest(".save-as-collapse")) ||
                Boolean(event.target.closest(".navbar-collapse"))
            ) {
                return false;
            }
        }

        this.collapseActiveInstance.hide();
    }

    setCollapseInstances() {
        const _this = this;
        let collapses = [].slice.call(this.caption.querySelectorAll(".collapse"));

        if (collapses.length > 0) {
            collapses.forEach(function (collapse, index) {
                _this.collapseInstances.set(
                    "#" + collapse.id,
                    new bootstrap.Collapse(collapse, {
                        toggle: false,
                    })
                );
            });
        }
    }

    toggleAll(target) {
        let items = target.closest(".save-as-collapse").querySelectorAll("a");

        items.forEach(function (item, index) {
            if (target.checked) {
                if (/pager_nolimit/.test(item.getAttribute("href"))) {
                    item.classList.add("d-flex");
                } else {
                    item.classList.add("d-none");
                }
            } else {
                if (/pager_nolimit/.test(item.getAttribute("href"))) {
                    item.classList.remove("d-flex");
                } else {
                    item.classList.remove("d-none");
                }
            }
        });
    }

    //// Sprawdzenie i ustawienie położenia okna.
    //                 /!*let windowInnerHeight = window.innerHeight;
    //                 let bottom = 0;
    //
    //                 if (Tools.matchMedia("(min-width: 1200px)")) {
    //                     bottom = event.target.getBoundingClientRect().bottom;
    //                 } else {
    //                     if (event.target.classList.contains("navbar-collapse")) {
    //                         bottom = event.target.getBoundingClientRect().bottom;
    //                     } else if (event.target.classList.contains("save-as-collapse")) {
    //                         bottom = event.target.closest(".navbar-collapse").getBoundingClientRect().bottom;
    //                     }
    //                 }
    //
    //                 if (bottom >= windowInnerHeight) {
    //                     event.target.closest(".navbar-collapse").classList.add("navbar-collapse--bottom");
    //                 }*!/

    //// Reset położenia okna.
    //                 /!*if (event.target.classList.contains("navbar-collapse")) {
    //                     event.target.closest(".navbar-collapse").classList.remove("navbar-collapse--bottom");
    //                 }*!/

    init() {
        const _this = this;

        //
        this.setCollapseInstances();

        //
        this.events();

        //
        [].slice.call(document.querySelectorAll('[data-toggle="switch"]')).forEach(function (element, index) {
            _this.toggleAll(element);
        });
    }
}

export { TableCaption };
